//#region: Special Characters
export const SEMI_COLON = ';';
export const COMMA = ',';
//#endregion: Special Characters

//#region: Range Limits
export const DEFAULT_MAX_VERSIONS = '9999';
export const DEFAULT_MAX_SUBVERSIONS = '26';
//#endregion: Range Limits

export const LANGUAGE_ENU = 'ENU';
export const SEARCH_APP = '%SEARCH';